// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1JuLc","footer":"ModalCreateQualiphyProcedure_footer__39qVE","additionData":"ModalCreateQualiphyProcedure_additionData__1PeKu"};